export const createPopup = (msg) => {
    const popupDiv = document.createElement('div');
    popupDiv.className = 'popup';
    popupDiv.textContent = msg;
    document.body.appendChild(popupDiv);
    const offsetHeight = popupDiv.offsetHeight;
  
    popupDiv.style.transform = 'translate(-100%, 0)';
  
    setTimeout(() => {
      popupDiv.style.transform = 'translateX(100%)';
      setTimeout(() => {
        document.body.removeChild(popupDiv);
      }, 500);
    }, 3000);
  };
  